import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import {
  Box,
  Button,
  Chip,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';

import type { AiCampaignDto } from '@/shared/api/ai-campaigns';

export function CampaignList({
  campaigns,
  selectedId,
  onSelect,
  onCreate,
}: {
  campaigns: AiCampaignDto[];
  selectedId: string | null;
  onSelect: (campaign: AiCampaignDto) => void;
  onCreate: () => void;
}) {
  return (
    <Stack spacing={1.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="h6">AI-кампании</Typography>
          <Typography variant="body2" color="text.secondary">
            Черновики, расписание и статус отправки
          </Typography>
        </Box>
        <Button
          size="small"
          variant="contained"
          startIcon={<AddOutlinedIcon />}
          onClick={onCreate}
        >
          Создать
        </Button>
      </Stack>

      <List
        disablePadding
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden',
          bgcolor: 'background.paper',
        }}
      >
        {campaigns.length === 0 ? (
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Кампаний пока нет.
            </Typography>
          </Box>
        ) : (
          campaigns.map((campaign) => (
            <ListItemButton
              key={campaign.id}
              selected={campaign.id === selectedId}
              onClick={() => onSelect(campaign)}
              sx={{ alignItems: 'flex-start', gap: 1 }}
            >
              <ListItemText
                primary={campaign.name}
                secondary={`${campaign.recipient_count} получателей · ${campaign.schedule.mode === 'scheduled' ? campaign.schedule.start_at ?? 'по расписанию' : 'ручной запуск'}`}
                primaryTypographyProps={{ fontWeight: 800, noWrap: true }}
                secondaryTypographyProps={{ noWrap: true }}
              />
              <Chip
                size="small"
                variant="outlined"
                label={campaign.status}
                sx={{ borderRadius: 1, mt: 0.25 }}
              />
            </ListItemButton>
          ))
        )}
      </List>
    </Stack>
  );
}
